import { Component, input, output, inject, computed } from '@angular/core';
import { Router } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { App_Routes } from '../../enums/router.enum';
import { UiService } from '../../services/ui.service';

@Component({
  standalone: true,
  selector: 'app-nav-button',
  imports: [NzIconModule],
  templateUrl: './nav-button.html',
  styleUrls: ['./nav-button.scss'],
})
export class NavButtonComponent {
  asset = input<any | undefined>(undefined); // Prince need to check this
  primary = input<boolean>(false);
  darksecondary = input<boolean>(false);
  lighttertiary = input<boolean>(false);
  href = input<string | undefined>(undefined); // Prince need to check this
  disabled = input<boolean>(false);
  blackBorder = input<boolean>(false);
  whiteBorder = input<boolean>(false);
  whiteBG = input<boolean>(false);
  svgIcon = input<string>(GLOBAL_CONSTANT.EMPTY_STRING); // Prince need to check this
  onlyIcon = input(false as boolean);
  svgIconRight = input(GLOBAL_CONSTANT.EMPTY_STRING); // Prince need to check this
  bodyBold = input<boolean>(false); // true for body-bold, false for button-link
  wide = input<boolean>(true); // true for 320px (desktop) & 100% (mobile)
  flexible = input<boolean>(false);
  fullwidth = input<boolean>(false);
  smol = input(false as boolean);
  mailto = input<string | null>(null);
  isScan = input<boolean>(false);

  // Output converted to a signal
  clickEvent = output<void>();
  private router = inject(Router);
  private ui = inject(UiService);
  isMobile = computed(() => this.ui.IsMobile());

  classes = computed(() =>
    [
      this.primary() && 'primary',
      this.darksecondary() && 'dark-sec',
      this.lighttertiary() && 'lighttertiary',
      this.blackBorder() && 'black-border',
      this.whiteBorder() && 'white-border',
      this.whiteBG() && 'white-bg',
      this.onlyIcon() && 'svg-icon-only',
      this.bodyBold() && 'body-bold',
      this.wide() && 'wide',
      this.flexible() && 'flexible',
      this.fullwidth() && 'fullwidth',
      this.smol() && 'smol',
      this.isScan() && 'is-scan',
      this.disabled() && 'disabled',
      'button',
      'nav-button',
    ]
      .filter(Boolean)
      .join(' ')
  );

  onClick(event: Event) {
    // Prevent default navigation if href is not provided
    if (!this.href()) {
      event.preventDefault();
    }
    event.stopPropagation();

    // Access signal values using their function call syntax (e.g., this.disabled())
    if (!this.disabled()) {
      this.clickEvent.emit(); // Emit the output signal

      if (this.mailto()) {
        window.open('mailto:' + this.mailto(), '_self');
        return;
      }

      if (this.asset()) {
        // Using setTimeout as in original, though consider if it's still necessary
        setTimeout(() => this.router.navigate([App_Routes.PLANT, this.asset().objectID]));
      }
    }
  }
}
